<template>
  <div class="reason-response-field">
    <div class="mb-4">
      <div class="w-full mb-4">
        <strong>{{ name }}</strong>
      </div>

      <div class="w-full">
        <vs-input
          type="number"
          class="w-full"
          v-model="value"
          @change="updateValue"
          :name="'decimal' + index"
          v-validate="isRequired ? 'required' : '' "
          :disabled="disabled"
        />
      </div>

      <span class="text-danger text-sm" v-show="errors.has('decimal' + index)">
        Preenchimento do campo é obrigatório.
      </span>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'DecimalField',
    inject: ['$validator'],
    props: {
      index: {
        type: Number,
        required: true
      },
      items: {
        type: Array,
        required: false
      },
      description: {
        required: false
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    data() {
      return {
        value: 0,
        isRequired: false
      }
    },  
    computed:  {
      name(){
        if ( !this.description || this.description.description == ''){
          return;
        } 
        else if ( this.description.description ){
          return this.description.description;
        }
        return this.description;
      }
    },
    methods: {
      updateValue() {
        this.$emit('valueChanged', this.index, 0, this.value)
      }
    },
    created() {
      if (!this.items) { return;}
      this.items.forEach((item) => {
        this.isRequired = item.reason_option_is_required
        
        if(!item.value){ return; }
        this.value = item.value.toString()
      })
    }
  }
</script>
